import React, { useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames/bind';
import styles from './Toast.scss';
const cx = classNames.bind(styles);

const Toast = ({ item = {}, name, timeout }) => {
  // console.log({ item });
  const interval = timeout || 2000;
  let toastWrapper = useRef();

  useEffect(() => {
    if (item) pushToast(item);

    // console.log(item);
  }, [item]);

  const pushToast = useCallback(
    async item => {
      const callback = (toast, wrapper) => {};
      // console.log({ toastWrapper });
      // handleToast(item, name, toastWrapper.current, interval, callback);
      handleToastSingle(item, name, toastWrapper.current, interval, callback);
    },
    [handleToastSingle, name, toastWrapper, interval],
  );

  return <div className={cx('Toast')} ref={toastWrapper}></div>;
};

export default Toast;

const handleToastSingle = (item, name, wrapper, timeout = 3000, callback) => {
  while (wrapper.hasChildNodes()) {
    wrapper.removeChild(wrapper.firstChild);
  }

  let content = document.createElement('div');
  content.classList = 'toast-item ' + name;
  content.classList.add('appear');

  ReactDOM.render(<span>{item.message}</span>, content);
  wrapper.appendChild(content);

  setTimeout(() => {
    content.addEventListener('animationend', e => {
      if (wrapper.children.length) wrapper.removeChild(content);
    });
    content.classList.remove('appear');
    content.classList.add('disappear');
    callback(item, wrapper);
  }, timeout);
};
